import { render, staticRenderFns } from "./b-menu-pagination-actions.vue?vue&type=template&id=11548afc&scoped=true&"
import script from "./b-menu-pagination-actions.vue?vue&type=script&lang=js&"
export * from "./b-menu-pagination-actions.vue?vue&type=script&lang=js&"
import style0 from "./b-menu-pagination-actions.vue?vue&type=style&index=0&id=11548afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11548afc",
  null
  
)

export default component.exports